import { render, staticRenderFns } from "./jjy.vue?vue&type=template&id=0bd7c8e6"
import script from "./jjy.vue?vue&type=script&lang=js"
export * from "./jjy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports